import React, { useEffect, useState } from "react";
import {
  addIngredient,
  deleteIngredient,
  editIngredient,
  getIngredientsByMenu,
} from "../Services/IngredientsApi";
import { Link, useParams } from "react-router-dom";
import swal from "sweetalert";
import { getOrganisationById } from "../Services/OrganizationApi";
import { useOrganisations } from "../Auth/useOrganisations";
import { toast } from "react-toastify";

function Ingredients() {
  const [ingredientsList, setIngredientsList] = useState([]);
  const [titre, setTitre] = useState("");
  const [prix, setPrix] = useState("");
  const [currency, setCurrency] = useState("");

  const { id } = useParams(); // Menu ID
  const [rand, setRand] = useState(0);
  const [ingredientToEdit, setIngredientToEdit] = useState(null);

  const [
    organisations,
    setOrganisations,
    usedOrganisations,
    setUsedOrganisations,
  ] = useOrganisations();

  // Reset form fields
  const resetForm = () => {
    setTitre("");
    setPrix("");
    setIngredientToEdit(null);
  };

  const promptForDelete = (ingredient_id) => {
    swal({
      title: "Êtes-vous sûr ?",
      text: "Une fois supprimé, cet ingrédient sera définitivement retiré !",
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        deleteIngredient(ingredient_id).then((res) => {
          if (res && res.data.success) {
            swal("Supprimé !", "L'ingrédient a été retiré.", "success");
            setRand((prev) => prev + 1);
          } else {
            toast.error("Erreur lors de la suppression");
          }
        });
      }
    });
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    if (!titre) {
      toast.error("Le titre est requis");
      return;
    }

    const priceValue = prix ? parseFloat(prix) : 0;

    if (ingredientToEdit) {
      // Edit Mode
      editIngredient(titre, priceValue, id, ingredientToEdit).then((res) => {
        if (res.data.success !== "0") {
          document.getElementById("dismissModal").click();
          resetForm();
          setRand((prev) => prev + 1);
          toast.success("Ingrédient mis à jour");
        } else {
          toast.error("Erreur lors de la modification");
        }
      });
    } else {
      // Add Mode
      addIngredient(titre, priceValue, id).then((res) => {
        if (res.data.success !== "0") {
          document.getElementById("dismissModal").click();
          resetForm();
          setRand((prev) => prev + 1);
          toast.success("Ingrédient ajouté");
        } else {
          toast.error("Erreur lors de l'ajout");
        }
      });
    }
  };

  const openEditModal = (item) => {
    setIngredientToEdit(item.id || item._id);
    setTitre(item.titre);
    setPrix(item.prix_ttc || "");
    document.getElementById("openModal").click();
  };

  useEffect(() => {
    // Load ingredients
    getIngredientsByMenu(id).then((res) => {
      if (res.data.success !== "0") {
        setIngredientsList(res.data.data);
      }
    });

    // Load Currency from Organization
    if (usedOrganisations) {
      getOrganisationById(usedOrganisations).then((res) => {
        if (res.data.success !== "0") {
          setCurrency(res.data.data.currency || "");
        }
      });
    }
  }, [id, rand, usedOrganisations]);

  return (
    <section className="content">
      <div className="row">
        <div className="col-12 d-flex justify-content-between align-items-center mb-20">
          <h2>Ingredients & Suppléments</h2>
          <Link to={`/menus/edit/${id}`} className="btn btn-secondary btn-sm">
            Retour au Menu
          </Link>
        </div>

        <div className="col-lg-12">
          <div className="box">
            <div className="media-list media-list-divided media-list-hover">
              {ingredientsList && ingredientsList.length > 0 ? (
                ingredientsList.map((item, index) => (
                  <div
                    key={item.id || index}
                    className="media align-items-center"
                  >
                    <div className="media-body">
                      <p>
                        <strong className="font-size-16">
                          {item.titre}
                          {item.prix_ttc > 0 && (
                            <span className="text-success ml-10">
                              + {parseFloat(item.prix).toFixed(3)} {currency}
                            </span>
                          )}
                        </strong>
                      </p>
                    </div>

                    <div className="media-right gap-items">
                      <button
                        className="btn btn-pure btn-danger ti-trash"
                        onClick={() => promptForDelete(item.id || item._id)}
                        title="Supprimer"
                      />
                      <button
                        className="btn btn-pure btn-info ti-pencil"
                        onClick={() => openEditModal(item)}
                        title="Modifier"
                      />
                    </div>
                  </div>
                ))
              ) : (
                <div className="p-20 text-center text-muted">
                  Aucun ingrédient trouvé.
                </div>
              )}

              <div className="box-body text-center">
                <button
                  className="btn btn-circle btn-success"
                  data-toggle="modal"
                  data-target="#myModal"
                  id="openModal"
                  onClick={resetForm}
                >
                  <i className="ti-plus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <div
        id="myModal"
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {ingredientToEdit
                  ? "Modifier l'ingrédient"
                  : "Ajouter un ingrédient"}
              </h4>
              <button type="button" className="close" data-dismiss="modal">
                ×
              </button>
            </div>
            <form onSubmit={onSubmit}>
              <div className="modal-body">
                <div className="form-group">
                  <label>Titre *</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Ex: Fromage, Supplément Frites..."
                    value={titre}
                    onChange={(e) => setTitre(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Prix Supplémentaire ({currency})</label>
                  <div className="input-group">
                    <div className="input-group-addon">
                      <i className="ti-money"></i>
                    </div>
                    <input
                      type="number"
                      step="0.001"
                      className="form-control"
                      placeholder="0.000"
                      value={prix}
                      onChange={(e) => setPrix(e.target.value)}
                    />
                  </div>
                  <small className="form-text text-muted">
                    Laissez à 0 si l'ingrédient est gratuit.
                  </small>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  id="dismissModal"
                  className="btn btn-default"
                  data-dismiss="modal"
                >
                  Annuler
                </button>
                <button type="submit" className="btn btn-success">
                  {ingredientToEdit
                    ? "Enregistrer les modifications"
                    : "Ajouter au menu"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Ingredients;
